import { CompaniesInfoRES } from 'src/pages/MainPage/_BLL/types';
import { RequestStatus, UrlAPI } from 'src/shared/api/types';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { apiRequest } from 'src/shared/api/api';

const NAME = 'userInfo';

// * Thunks
const companiesLookup = createAsyncThunk(`${NAME}/companiesLookup`, async (_: void, thunkAPI) => {
	return await apiRequest.getRequest<CompaniesInfoRES>({
		url: UrlAPI.companiesLookup,
		thunkAPI,
	});
});

// * Reducer
interface State {
	companiesLookupResult: CompaniesInfoRES | null;
	status: RequestStatus;
}

export const initialState: State = {
	companiesLookupResult: null,
	status: RequestStatus.still,
};

export const slice = createSlice({
	name: NAME,
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder.addCase(companiesLookup.pending, (state) => {
			state.status = RequestStatus.loading;
		});
		builder.addCase(companiesLookup.fulfilled, (state, action) => {
			state.companiesLookupResult = action.payload;
			state.status = RequestStatus.still;
		});
		builder.addCase(companiesLookup.rejected, (state) => {
			state.status = RequestStatus.failed;
		});
	},
});

export const actionsUserInfo = {
	...slice.actions,
	getCompanies: companiesLookup,
};
